/**
 * Product Utility functions for Handmade Haven
 */

/**
 * Extracts display information for a product, prioritizing the lowest priced variant.
 * @param {Object} product - The product object from productsData.js
 * @returns {Object} - Display information including image and price
 */
export const getProductDisplayInfo = (product) => {
  if (!product) return { displayImage: '', displayPrice: 0, lowestPriceVariant: null };

  const options = product.type === 'variant' ? product.variants : 
                  product.type === 'size' ? product.sizes : null;

  if (options && options.length > 0) {
    // Find variant with the lowest price
    const lowestPriceVariant = options.reduce((prev, curr) => 
      (curr.price < prev.price) ? curr : prev
    );

    return {
      displayImage: lowestPriceVariant.image || product.image,
      displayPrice: lowestPriceVariant.price,
      lowestPriceVariant: lowestPriceVariant,
      variantIndex: options.indexOf(lowestPriceVariant)
    };
  }

  // Fallback for single products or products without variants
  return {
    displayImage: product.image,
    displayPrice: product.price || 0,
    lowestPriceVariant: null,
    variantIndex: -1
  };
};
